var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 3.22218C17.5751 2.95423 16.9685 3.28853 16.9685 3.8237V8.47218C16.9685 8.72024 17.1069 8.94949 17.3317 9.07369L21.5358 11.3968C22.0207 11.6648 22.6273 11.3305 22.6273 10.7953V6.14683C22.6273 5.89877 22.4889 5.66952 22.2641 5.54532L18.06 3.22218Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 14.926C17.1084 15.0504 16.831 15.0505 16.6058 14.9264L12.3873 12.6012C11.9024 12.334 11.2965 12.6683 11.2965 13.2031V23.3041C11.2965 23.8391 11.9027 24.1734 12.3876 23.9058L22.265 18.4546C22.49 18.3305 22.6286 18.1011 22.6286 17.8529V13.2047C22.6286 12.6695 22.0219 12.3352 21.537 12.6032L17.3335 14.926Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56854 20.7778C5.05344 21.0458 5.66006 20.7115 5.66006 20.1763V15.5278C5.66006 15.2798 5.52165 15.0505 5.29688 14.9263L1.09281 12.6032C0.607908 12.3352 0.00128395 12.6695 0.00128395 13.2047V17.8532C0.00128395 18.1012 0.139698 18.3305 0.36446 18.4547L4.56854 20.7778Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29507 9.07399C5.52012 8.94963 5.79753 8.94948 6.02272 9.0736L10.2413 11.3988C10.7262 11.666 11.3321 11.3317 11.3321 10.7969V0.695925C11.3321 0.160928 10.7258 -0.173392 10.2409 0.0942163L0.363528 5.54538C0.138568 5.66954 0 5.89889 0 6.14709V10.7953C0 11.3305 0.606625 11.6648 1.09152 11.3968L5.29507 9.07399Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlackLogo);
export default __webpack_public_path__ + "static/media/LinkBlackLogo.3ebc5f0a9de98b98f3bbe87c47495dd3.svg";
export { ForwardRef as ReactComponent };